import React from 'react';
import {Row,Modal} from 'antd';
import {connect} from 'react-redux';
import {app_SET} from '../redux/actions/appAction';

class ModalBase extends React.Component {
	
	render(){
		
		const {app} = this.props;
		const {APPloading} = app;
	
		return (
		
			
			<Modal visible={APPloading} keyboard={false} closable ={false} footer={null}>
			
				处理中		
			
			
			</Modal>
			
			 
		)
	
	}
	
}


 const mapStateToProps = (state) => {
  return {
    app: state.appReducer   
	}
}

const mapDispatchToProps = (dispatch,ownProps) => {
  return {  	
	app_set: (value)=>dispatch(app_SET(value))		
	}
}

const LoadingModal =connect(mapStateToProps,mapDispatchToProps)(ModalBase);

export default LoadingModal;
